export default "__VITE_ASSET__DID7vCij__"